import Swiper, {Navigation, Pagination} from 'swiper';

const textSlider = document.querySelector('.j-about-constructor__slider-texts');
const imageSlider = document.querySelector('.j-about-constructor__slider-images');

let imageSliderInstance = '';
let textSliderInstance = '';

if (textSlider) {
    textSliderInstance = new Swiper(textSlider, {
        modules         : [Navigation],
        init            : false,
        loop            : true,
        direction       : 'vertical',
        wrapperClass    : 'j-about-constructor__slider-wrapper',
        slideClass      : 'j-about-constructor__slider-slide',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 'auto',
        navigation      : {
            prevEl       : '.j-about-constructor__slider-prev',
            nextEl       : '.j-about-constructor__slider-next',
            disabledClass: 'is-disabled'
        }
    });

    textSliderInstance.init();
}

if (imageSlider) {
    imageSliderInstance = new Swiper(imageSlider, {
        modules         : [Pagination],
        init            : false,
        loop            : true,
        wrapperClass    : 'j-about-constructor__slider-wrapper',
        slideClass      : 'j-about-constructor__slider-slide',
        slideActiveClass: 'is-active',
        slideNextClass  : 'is-next',
        slidesPerView   : 'auto',
        pagination      : {
            el: '.j-about-constructor__slider-pagination',

            type: 'custom',

            renderCustom(_, current, total) {
                return `<span class="slider-control__current">${current.toString()}</span>/
                           <span class="slider-control__total"> ${total.toString()}</span>`;
            }
        }
    });

    imageSliderInstance.init();
}

if (imageSliderInstance.initialized) {
    textSliderInstance.on('slideChange', () => {
        imageSliderInstance.slideTo(textSliderInstance.activeIndex);
    });
}
